import { apiCall } from 'api';
import { USER_ISLOGGEDIN_SERVICE_PATH } from 'api/services/content/paths';
import { getHKS } from 'utils/HKS';

export const isloggedinService = params => {
  const { claroLiteConfig, ...restParams } = params;
  restParams.api_version = null;
  const HKS = apiCall?.defaults?.params?.HKS || getHKS();
  return apiCall.get(USER_ISLOGGEDIN_SERVICE_PATH, {params: {...restParams, HKS   } });
}
